import React, { useState } from 'react';
import { Edit, Loader2, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { BackButton } from '@/components/ui/BackButton';
import { ProcessorDetails, useDeleteProcessors } from '@/lib/api/processors';
import { Link } from 'react-router-dom';

import { ProcessorDeleteDialog } from './processor-delete-dialog';
import { getProcessorEditRoute } from './processor-edit-route';
import { useOrgNavigate } from '@/hooks/use-app-navigate';
interface ProcessorHeaderProps {
  type:
  | 'stripe'
  | 'nmi'
  | 'onyx'
  | 'routesense'
  | 'finix'
  | 'mastercard'
  | 'airwallex'
  | 'checkout'
  | 'tagadapay'
  | 'tagadapay-router'
  | 'efipayments'
  | 'merchantscale'
  | 'bakolapay'
  | 'sandbox'
  | 'trustflow'
  | 'kesspay'
  | 'ovri'
  | 'ccavenue'
  | 'ngenius'
  | 'tap'
  | 'authorizenet'
  | 'convesio'
  | 'adyen'
  | 'payland'
  | 'paysafe'
  | 'bluesnap'
  | 'worldpay'
  | 'braintree'
  | 'mollie'
  | 'fiserv'
  | 'paystack'
  | 'payu'
  | 'razorpay'
  | 'payone'
  | 'globalpay'
  | 'buzipay'
  | 'netvalve'
  | 'xoala'
  | 'unlimit'
  | 'generic';
  processor: ProcessorDetails;
}

export const ProcessorHeader = ({ type, processor }: ProcessorHeaderProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const { t } = useTranslation('processors');
  const { orgRoutes } = useOrgNavigate();

  const editRoute = getProcessorEditRoute(orgRoutes, type, processor.id);

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <BackButton to={`${orgRoutes.PAYMENT_FLOWS()}?tab=processors`} />
        <h1 className="text-2xl font-semibold">{processor.name}</h1>
      </div>

      <div className="flex gap-2">
        {editRoute && (
          <Link to={editRoute}>
            <Button variant="outline">
              <Edit className="mr-2 h-4 w-4" />
              {t('edit')}
            </Button>
          </Link>
        )}
        <Button variant="destructive" onClick={() => setShowDeleteDialog(true)}>
          <Trash2 className="mr-2 h-4 w-4" />
          {t('delete')}
        </Button>
      </div>
      <ProcessorDeleteDialog
        processor={processor}
        open={showDeleteDialog}
        onOpenChange={setShowDeleteDialog}
      />
    </div>
  );
};
